<template>
  <div>
    <v-row align="center">
      <v-col cols="12" sm="6">
        <v-text-field
          label="Matricula"
          v-model="matricula"
          v-mask="['###############']"
          :counter="15"
          :rules="[(v) => !!v || 'A Matricula é obrigatória']"
          required
          :readonly="isAllowed"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          label="Nome"
          v-model="nome"
          :counter="200"
          :rules="[(v) => !!v || 'O Nome é obrigatória']"
          required
          :readonly="isAllowed"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col cols="12" sm="6">
        <v-text-field
          label="Email"
          v-model="email"
          :counter="200"
          :rules="[
            (v) => !!v || 'O Email é obrigatório',
            (v) => /.+@.+\..+/.test(v) || 'O Email deve ser válido',
          ]"
          required
          :readonly="isAllowed"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          label="Telefone"
          v-model="telefone"
          v-mask="['(##) ####-####', '(##) #####-####']"
          :counter="15"
          :rules="[
            (v) => !!v || 'O Telefone é obrigatório',
            (v) =>
              (v && v.length >= 14) || 'Telefone deve ter 14 ou 15 caracteres',
          ]"
          required
          :readonly="isAllowed"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col cols="12" sm="6">
        <v-autocomplete
          v-model="departamentoSelected"
          :items="departamentos"
          label="Departamento"
          item-text="descricao"
          item-value="id"
          persistent-hint
          return-object
          :rules="[
            (v) =>
              v.map((a) => a.id).length > 0 || 'O Departamento é obrigatório',
          ]"
          required
          :clearable="!isAllowed"
          multiple
          :readonly="isAllowed"
        >
          <template v-slot:prepend-item>
            <v-list-item ripple @click="toggleDepartamento">
              <v-list-item-action>
                <v-icon
                  :color="
                    departamentoSelected.length > 0 ? 'indigo darken-4' : ''
                  "
                >
                  {{ iconDp }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Selecionar Todos </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6">
        <v-autocomplete
          v-model="cargoSelected"
          :items="cargos"
          label="Cargo"
          item-text="descricao"
          item-value="id"
          persistent-hint
          return-object
          :rules="[(v) => !!v || 'O Cargo é obrigatório']"
          required
          :readonly="isAllowed"
        >
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col cols="12" sm="6">
        <v-autocomplete
          v-model="perfilSelected"
          :items="perfis"
          label="Perfil"
          item-text="nome"
          item-value="id"
          persistent-hint
          return-object
          :rules="[(v) => !!v || 'O Perfil é obrigatório']"
          required
          :readonly="isAllowed"
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6">
        <v-autocomplete
          v-model="unidadeAdmSelected"
          :items="unidadesAdm"
          label="Unidade Adm"
          item-text="descricao"
          item-value="id"
          persistent-hint
          return-object
          :rules="[
            (v) =>
              v.map((a) => a.id).length > 0 || 'A Unidade Adm é obrigatório',
          ]"
          required
          :clearable="!isAllowed"
          multiple
          :readonly="isAllowed"
        >
          <template v-slot:prepend-item>
            <v-list-item ripple @click="toggle">
              <v-list-item-action>
                <v-icon
                  :color="
                    unidadeAdmSelected.length > 0 ? 'indigo darken-4' : ''
                  "
                >
                  {{ icon }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Selecionar Todos </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row align="center" v-if="isReqRolls">
      <v-col cols="12" sm="6">
        <v-autocomplete
          v-model="departamentoCompradorIds"
          :items="departamentoSelected"
          label="Departamento (Comprador)"
          item-text="descricao"
          item-value="id"
          multiple
          chips
          :clearable="!isAllowed"
          :readonly="isAllowed"
          persistent-hint
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "formularioUsuario",
  data: () => ({
    matricula: null,
    nome: null,
    email: null,
    telefone: null,
    departamentoSelected: [],
    cargoSelected: null,
    perfilSelected: null,
    unidadeAdmSelected: [],
    departamentoCompradorIds: [],
  }),

  props: {
    perfis: Array,
    departamentos: Array,
    cargos: Array,
    unidadesAdm: Array,
    permissoes: Array,
    isAllowed: Boolean,
  },
  computed: {
    checksAllUnidades() {
      return this.unidadeAdmSelected.length === this.unidadesAdm.length;
    },
    checksSomeUnidades() {
      return this.unidadeAdmSelected.length > 0 && !this.checksAllUnidades;
    },
    icon() {
      if (this.checksAllUnidades) return "mdi-close-box";
      if (this.checksSomeUnidades) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    checksAllDps() {
      return this.departamentoSelected.length === this.departamentos.length;
    },
    checksSomeDps() {
      return this.departamentoSelected.length > 0 && !this.checksAllDps;
    },
    iconDp() {
      if (this.checksAllDps) return "mdi-close-box";
      if (this.checksAllDps) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    usuarioDepartamentosPayload() {
      const idsComprador = this.departamentoCompradorIds || [];

      return (this.departamentoSelected || []).map((d) => ({
        id: 0, // ou null, dependendo do seu backend
        idUsuario: this.usuario?.id || 0, // ajuste conforme seu form
        idDepartamento: d.id,
        comprador: idsComprador.includes(d.id),
      }));
    },
    
    isReqRolls() {
      if (this.perfilSelected == null) {
        return false;
      } else {
        var permissao = this.permissoes.find((p) => {
          return this.perfilSelected.idPermissao === p.id;
        });
        var regra = permissao.regras.find((p) => {
          return p.moduloId === 10;
        });
        if (regra == null || !regra.escrita) {
          this.departamentoCompradorIds = []
        }
        return regra != null && regra.escrita;
      }
    },
  },
  watch: {
    departamentoSelected: {
      deep: true,
      handler(novo) {
        const idsSelecionados = (novo || []).map((d) => d.id);

        // 1) remove do campo 2 quem não está mais no campo 1
        this.departamentoCompradorIds = (
          this.departamentoCompradorIds || []
        ).filter((id) => idsSelecionados.includes(id));

        // 2) adiciona no campo 2 (marcado) os novos ids do campo 1
        for (const id of idsSelecionados) {
          if (!this.departamentoCompradorIds.includes(id)) {
            this.departamentoCompradorIds.push(id); // default: true
          }
        }
      },
    },
  },
  methods: {
    fillForm(usuario) {
      this.matricula = usuario.matricula;
      this.nome = usuario.nome;
      this.email = usuario.email;
      this.telefone = usuario.telefone;
      //this.departamentoSelected = this.findDepartamento(usuario.departamentos);
      this.cargoSelected = this.findCargo(usuario.idCargo);
      this.perfilSelected = this.findPerfil(usuario.idPerfil);
      this.unidadeAdmSelected = this.findUnidadeAdm(usuario.idLocal);
      this.carregarDepartamentosDoUsuario(usuario.departamentos);
    },

    findDepartamento(idsDepartamentos) {
      return this.departamentos.filter((dp) =>
        idsDepartamentos.includes(dp.id)
      );
    },
    findCargo(cargoId) {
      return this.cargos.find((cg) => cg.id === cargoId);
    },
    findPerfil(perfilId) {
      return this.perfis.find((pf) => pf.id === perfilId);
    },
    findUnidadeAdm(unidadesId) {
      //return this.unidadesAdm.find((ud) => ud.id === unidadeId);
      /*return this.unidadesAdm.filter(function (element) {
        JSON.stringify(element.id.split(' '));
        var ids = element.id.split(' ');
        return (
          ids.filter(function (identity) {
            return ids.indexOf(identity) > -1;
          }).length === unidadesId.length
        );
      });*/
      return this.unidadesAdm.filter((und) => unidadesId.includes(und.id));
    },
    toggle() {
      this.$nextTick(() => {
        if (this.checksAllUnidades) {
          this.unidadeAdmSelected = [];
        } else {
          this.unidadeAdmSelected = this.unidadesAdm.slice();
        }
      });
    },
    toggleDepartamento() {
      this.$nextTick(() => {
        if (this.checksAllDps) {
          this.departamentoSelected = [];
        } else {
          this.departamentoSelected = this.departamentos.slice();
        }
      });
    },
    carregarDepartamentosDoUsuario(listaUsuarioDepto) {
      // listaUsuarioDepto: [{idDepartamento, comprador}, ...]
      const ids = listaUsuarioDepto.map((x) => x.idDepartamento);

      // Preenche o campo 1 com objetos completos
      this.departamentoSelected = this.departamentos.filter((d) =>
        ids.includes(d.id)
      );

      // Preenche o campo 2 somente com os que são comprador=true
      this.departamentoCompradorIds = listaUsuarioDepto
        .filter((x) => x.comprador)
        .map((x) => x.idDepartamento);
    },
  },
};
</script>
